import { enableBodyScroll, disableBodyScroll } from '~js/utils/dom';

const MobileMenuOverlay = {
  openMobileMenuCTA: null,
  mobileMenuOverlayContainer: null,
  mobileMenuOverlay: null,
  mobileMenuOverlayCloseCTA: null,
  mobileToggleNestedDropDownCTA: null,

  init() {
    this.initiliaseElement();
    this.initialiseMobileOverlayEvents();
  },

  initiliaseElement() {
    this.openMobileMenuCTA = document.querySelector('.js-mobile-menu-cta');
    this.mobileMenuOverlayContainer = document?.querySelector(
      '.js-mobile-menu-overlay-container',
    );
    this.mobileMenuOverlay = document?.querySelector('.js-mobile-menu-overlay');
    this.mobileMenuOverlayCloseCTA =
      this.mobileMenuOverlayContainer?.querySelectorAll(
        '.js-mobile-menu-overlay-close-btn',
      );

    this.mobileToggleNestedDropDownCTA =
      this.mobileMenuOverlay?.querySelectorAll(
        '.js-mobile-toggle-nested-dropdown-cta',
      );
  },

  initialiseMobileOverlayEvents() {
    if (this.openMobileMenuCTA) {
      this.openMobileMenuCTA.addEventListener('click', () => {
        this.showMenu();
      });
    }

    if (this.mobileMenuOverlayCloseCTA) {
      this.mobileMenuOverlayCloseCTA.forEach((closeCTA) => {
        closeCTA.addEventListener('click', () => {
          this.hideMenu();
        });
      });
    }

    if (this.mobileToggleNestedDropDownCTA) {
      this.mobileToggleNestedDropDownCTA.forEach((button) => {
        button.addEventListener('click', (e) => {
          if (e.target.tagName.toLowerCase() === 'a') {
            return;
          }
          e.preventDefault();
          this.opendNestedDropDown(button);
        });
      });
    }

    if (this.mobileMenuOverlayContainer) {
      this.mobileMenuOverlayContainer.addEventListener('click', (e) => {
        if (e.target === this.mobileMenuOverlayContainer) {
          this.hideMenu();
        }
      });
    }
  },

  opendNestedDropDown(button) {
    const allDropdowns = this.mobileMenuOverlay?.querySelectorAll(
      '.js-mobile-nested-dropdown-menu-list',
    );
    const allToggles = this.mobileToggleNestedDropDownCTA;

    allDropdowns?.forEach((dropdown) => {
      const parentToggle = dropdown.closest(
        '.js-mobile-toggle-nested-dropdown-cta',
      );
      if (!parentToggle?.isSameNode(button)) {
        dropdown.classList.add('hidden');
      }
    });

    allToggles?.forEach((toggleBtn) => {
      const isCurrent = toggleBtn.isSameNode(button);
      const caretDown = toggleBtn.querySelector('.icon-caret-down');
      const caretUp = toggleBtn.querySelector('.icon-caret-up');

      if (!isCurrent) {
        toggleBtn.classList.add('items-center');
        caretDown?.classList.remove('hidden');
        caretUp?.classList.add('hidden');
      }
    });

    const dropdownMenu = button?.querySelector(
      '.js-mobile-nested-dropdown-menu-list',
    );
    const caretDown = button?.querySelector('.icon-caret-down');
    const caretUp = button?.querySelector('.icon-caret-up');

    if (dropdownMenu) {
      const isHidden = dropdownMenu.classList.contains('hidden');
      dropdownMenu.classList.toggle('hidden');

      if (isHidden) {
        button.classList.remove('items-center');
        caretDown?.classList.add('hidden');
        caretUp?.classList.remove('hidden');
      } else {
        button.classList.add('items-center');
        caretDown?.classList.remove('hidden');
        caretUp?.classList.add('hidden');
      }
    }
  },
  showMenu() {
    disableBodyScroll();
    this.mobileMenuOverlayContainer?.classList?.add('is-mobile-menu-open');
    this.mobileMenuOverlay?.classList?.add('is-mobile-menu-open');
  },

  hideMenu() {
    this.mobileMenuOverlayContainer?.classList?.remove('is-mobile-menu-open');
    this.mobileMenuOverlay?.classList?.remove('is-mobile-menu-open');
    enableBodyScroll();
  },
};

export default MobileMenuOverlay;
